import { createFileRoute } from '@tanstack/react-router';
import type { JSX } from 'react';

import { OrderUploadPage } from '@/areas/orders/Orders/pages/OrderUploadPage';
import { canUploadOrders } from '@/shared/permissions/pagePermissions';
import type { PageStaticData } from '@/shared/routing';
import { SidebarPageContent } from '@/shared/ui/PageLayoutCollapsibleSidebar';

// Not a copy of today's `/orders/upload`: a page of its own, beside the new orders list.
export const Route = createFileRoute('/_authenticated/next/orders/upload')({
    staticData: { access: { permissions: canUploadOrders }, chrome: 'none' } satisfies PageStaticData,
    component: RouteComponent,
});

function RouteComponent(): JSX.Element {
    return (
        <SidebarPageContent layoutVariant="fullWidth">
            <OrderUploadPage />
        </SidebarPageContent>
    );
}
